"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractorTier = void 0;
/**
 * Contractor Risk Tiering: risk tiers for HIL contractor-originated loan applications. See the
 * Contractor Risk Tiering - 1P spec. Kept in aven_types (not just aven_backend/util) because Python
 * underwriting reads the tier off the request payload and needs its own enum -- the string value is
 * the wire format between the two sides.
 */
/* @TranslateToPython @TranslateToEnum */
var ContractorTier;
(function (ContractorTier) {
    ContractorTier["tier1"] = "tier1";
    ContractorTier["tier2"] = "tier2";
    ContractorTier["tier3"] = "tier3";
})(ContractorTier || (exports.ContractorTier = ContractorTier = {}));
